export enum WeightChangeReasons {
  DRUG_WASHOUT = 'DRUG_WASHOUT',
  AFTER_HOSPITAL_STAY = 'AFTER_HOSPITAL_STAY',
  AT_LEAST_10_PERCENT_HOSPITAL_STAY = 'AT_LEAST_10_PERCENT_HOSPITAL_STAY',
  DIET_PRESCRIBED_BY_DOCTOR = 'DIET_PRESCRIBED_BY_DOCTOR',
}
